import {
  getObject,
  getLeoUuid,
  LeoUUID,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { FileAttributes, FileAttributesDTO } from "../types/fileAttributes";
/* eslint-disable import/export */
export abstract class InsertDocumentRecordRPC implements
  LeoRPC<InsertDocumentRecordRPC.Request, InsertDocumentRecordRPC.Response, InsertDocumentRecordRPC.Errors.Errors>
{
  abstract execute(
    request: InsertDocumentRecordRPC.Request
  ): Promise<LeoRPCResult<InsertDocumentRecordRPC.Response, InsertDocumentRecordRPC.Errors.Errors>>;
}

export namespace InsertDocumentRecordRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    fileAttributes: FileAttributesDTO;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isInsertDocumentRecordRPCRequest: boolean = true;
  
    readonly fileAttributes: FileAttributes;
  
  
    constructor(
    fileAttributes: FileAttributes
    ) {
      this.fileAttributes = fileAttributes;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const fileAttributes = FileAttributes.fromDTO(getObject(dto, "fileAttributes", InvalidRequestFileAttributesError));
      return new Request(
        fileAttributes
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          fileAttributes: this.fileAttributes.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `InsertDocumentRecordRPC(fileAttributes='${this.fileAttributes}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    documentId: string;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isInsertDocumentRecordResponse: boolean = true;
  
    readonly documentId: LeoUUID;
  
  
    constructor(
    documentId: LeoUUID
    ) {
      this.documentId = documentId;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const documentId = getLeoUuid(dto, "documentId", InvalidResponseDocumentIdError);
      return new Response(
        documentId
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          documentId: this.documentId.toDTO()
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `InsertDocumentRecord(documentId='${this.documentId}')`;
  };
  


  export namespace Errors {

    export type Errors = any;
    export type ErrorsDTO = any;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestFileAttributesError extends InsertDocumentRecordRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestFileAttributesError";
  }
}

export class InvalidResponseDocumentIdError extends InsertDocumentRecordRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseDocumentIdError";
  }
}

